export enum KeyboardEventKey {
    ArrowDown = 'ArrowDown',
    ArrowUp = 'ArrowUp',
    Enter = 'Enter',
    Escape = 'Escape',
    Tab = 'Tab',
    Space = ' ',
}
